import React, { useState } from 'react';
import { MultipleMediaUpload, AdminModal } from '@project/components';
import axios from '../../utils/axios';
import spaceProfileDefaults, { setDefaults } from '../SpaceProfile/defaults';
import { PUBLISHED } from '../../constants';
import { useIntl } from 'react-intl';
import styles from './ProfileImageUpload.module.css';

/**
 * This component is to open a popup that will handle file uploads attaching to the top level of a space profile
 */
export default function ProfileImageUpload({ spaceProfile, activeUploadModal, setSpaceProfile, setActiveUploadModal, setErrors }) {
  const intl = useIntl();
  const t = (id) => intl.formatMessage({id});

  const UPLOAD_LABELS = {photos: t('ProfileImageUpload.photos'), floorplans: t('ProfileImageUpload.floorplans')};

  const [isFilesUploadSaving, setIsFilesUploadSaving] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState(null);

  // handles photo saving for floorplans and images
  const handleSave = async (skipClose = false) => {
    setErrors(null);
    setIsFilesUploadSaving(true);

    const data = new FormData();
    if (uploadedFiles) uploadedFiles.forEach(file => data.append(activeUploadModal, file));
    data.append('spaceProfile', JSON.stringify(spaceProfile));

    try {
      let result = await axios.put(`/space-profiles/${spaceProfile.guid}`, data);
      setDefaults(spaceProfileDefaults, result.data.record);
      setSpaceProfile(result.data.record);
      setUploadedFiles(null);
    } catch (e) {
      return setErrors({ generic: `${t('error')}: ${e.errors || e}` });
    } finally {
      setIsFilesUploadSaving(false);
      if (!skipClose) setActiveUploadModal(null);
    }
  };

  // handles deleting photos for floorplans and images
  const onDeletePhoto = (photo) => {
    const photos = spaceProfile[activeUploadModal].filter(_ => _ !== photo);
    spaceProfile[activeUploadModal] = photos;
    setSpaceProfile({ ...spaceProfile });
  };

  return (
    <AdminModal
      title={intl.formatMessage({id: 'ProfileImageUpload.upload'}, {item: UPLOAD_LABELS[activeUploadModal] || activeUploadModal || ''})}
      show={!!activeUploadModal}
      onHide={() => setActiveUploadModal(null)}
      onSave={() => handleSave()}
      isSaving={isFilesUploadSaving}
      readOnly={spaceProfile.status === PUBLISHED}>
      <MultipleMediaUpload
        className={styles.profileImageUpload}
        mediaUrls={spaceProfile[activeUploadModal]}
        onDeleteMedia={onDeletePhoto}
        onSelectedMediaFiles={setUploadedFiles}
        readOnly={spaceProfile.status === PUBLISHED}
        type="image"
      />
    </AdminModal>
  )
}
